var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreennote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 679,
    height: 679,
    viewBox: "0 0 679 679",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.044 35.8066H55.842C41.7673 36.0087 30.3291 47.5454 30.3291 61.5171V89.1546H81.5525V61.5171C81.5525 47.5459 70.1134 36.0095 56.044 35.8066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.965 591.672V617.388C213.965 635.307 206.676 651.401 195.134 663.347H602.693C627.999 663.347 648.55 642.797 648.55 617.491V591.677L213.965 591.672Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M602.095 61.5087C602.095 36.2027 581.545 15.6523 556.239 15.6523H56.3384C81.4428 15.958 101.79 36.4043 101.79 61.6121L101.894 617.583C101.894 642.889 122.444 663.439 147.75 663.439C173.16 663.439 193.71 642.889 193.71 617.48V571.52H602.078L602.095 61.5087ZM272.077 127.915H322.695V77.2981H351.953V127.915H402.57V157.173H351.953V207.791H322.695V157.173H272.077V127.915ZM545.202 527.491H158.69V508.256H545.295V527.491H545.202ZM545.202 467.762H158.69V448.527H545.295V467.762H545.202ZM545.202 408.032H158.69V388.797H545.295V408.032H545.202ZM545.202 348.308H158.69V329.073H545.295V348.308H545.202ZM545.202 288.578H158.69V269.344H545.295V288.578H545.202Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 41,
    width: 218,
    height: 188,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreennote);
export default __webpack_public_path__ + "static/media/greennote.d40785e9b2da63a6f1e28ff679249030.svg";
export { ForwardRef as ReactComponent };